/** @file Event timeline: event indices per key plus int/float/string overrides (null = the default). */
import type { AnimationDoc, TimelineJson } from '@pose2d/format/types';
import { requireCompiledIndex } from './requireCompiledIndex';

const allNull = (xs: readonly unknown[]): boolean => xs.every((x) => x === null);

/** null without event keys; keys sorted by frame (several per frame allowed); all-null override arrays omitted. */
export function eventTimeline(anim: AnimationDoc, fps: number, eventIndex: ReadonlyMap<string, number>, at: string): TimelineJson | null {
  const keys = [...anim.events].sort((a, b) => a.f - b.f);
  if (keys.length === 0) return null;
  const int = keys.map((k) => k.int ?? null);
  const float = keys.map((k) => k.float ?? null);
  const string = keys.map((k) => k.string ?? null);
  return {
    k: 'event',
    t: keys.map((k) => k.f / fps),
    e: keys.map((k) => requireCompiledIndex(eventIndex, k.event, 'event', `${at}.events`)),
    ...(allNull(int) ? {} : { int }),
    ...(allNull(float) ? {} : { float }),
    ...(allNull(string) ? {} : { string }),
  };
}
